// extracted by mini-css-extract-plugin
export default {"panelHeader":"SidePanelHeader_panelHeader__g7h5C"};